export function OutlineNumberListIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2049 10.1816H11.7937C10.8023 10.1816 9.99854 10.9834 9.99854 11.9725V11.982C9.99854 12.9711 10.8023 13.7728 11.7937 13.7728H19.2049C20.1964 13.7728 21.0001 12.9711 21.0001 11.982V11.9725C21.0001 10.9834 20.1964 10.1816 19.2049 10.1816Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2049 3H11.7937C10.8023 3 9.99854 3.80177 9.99854 4.79081V4.80039C9.99854 5.78943 10.8023 6.5912 11.7937 6.5912H19.2049C20.1964 6.5912 21.0001 5.78943 21.0001 4.80039V4.79081C21.0001 3.80177 20.1964 3 19.2049 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2049 17.3652H11.7937C10.8023 17.3652 9.99854 18.167 9.99854 19.156V19.1656C9.99854 20.1547 10.8023 20.9564 11.7937 20.9564H19.2049C20.1964 20.9564 21.0001 20.1547 21.0001 19.1656V19.156C21.0001 18.167 20.1964 17.3652 19.2049 17.3652Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.99854 3V6.98863"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.0016 13.975H3C3 13.975 5.0016 11.3127 5.0016 10.9823C5.0016 10.4364 4.5504 9.98633 4.0032 9.98633C3.456 9.98633 3.0048 10.4364 3.0048 10.9823"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 18.0007C3 17.3495 3.6432 16.8324 4.3248 17.0574C4.7376 17.1915 5.0016 17.6033 5.0016 18.039C5.0016 18.5705 4.5696 19.0015 4.0368 19.0015M4.0368 19.0015H3.9984M4.0368 19.0015C4.5696 19.0015 5.0016 19.4324 5.0016 19.9639C5.0016 20.438 4.6896 20.8689 4.224 20.9742C3.5808 21.1179 3 20.6199 3 20.0022"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
